module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/chapimage.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("To “Chipmunk” Belle, child of light,"), _c('br'), _vm._v("and her fairy rings:")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("Club Weirdo:")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("Haley “Elvis” Schricker, Jesse “Otter” Greenfield, Emily"), _c('br'), _vm._v("“BobThing” Hogan, Steffi “Staff” Sontgerath, and"), _c('br'), _vm._v("Julia Jules” and Mandy “Mandy-Candy” Escobedo")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("The Ones Who Were There Before the Beginning:")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("Grace Beck, Sarah Wilcox, Melody and Mallory"), _c('br'), _vm._v("Muehlbauer, and Alexandra and Anna Rose Morel")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("And with gratitude, love, and deep respect to:")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("Melanie Tern,"), _c('br'), _vm._v("CLG,"), _c('br'), _vm._v("and my mother, Marion Elise Smith")])]), _c('p', {
    staticClass: "chapimage1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/chapimage.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "center3"
  }, [_c('em', [_vm._v("Love is much like a wild rose, beautiful and calm,"), _c('br'), _vm._v("but willing to draw blood in its own defense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "attributionz"
  }, [_vm._v("—Mark Overby")]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_c('em', [_vm._v("Love looks not with the eyes, but with the mind;"), _c('br'), _vm._v("And therefore is winged Cupid painted blind")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "attributionz"
  }, [_vm._v("—William Shakespeare")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0